<app-load-spinner-wrapper [loading]="loading">
  <div class="mt-4">
    <div class="flex items-center gap-4 mb-1">
      <h2 class="text-lg"><strong>Provider Groups:</strong></h2>
      <button mat-raised-button color="primary" type="button" [disabled]="refreshing" (click)="onRefresh()">{{ refreshing ? (refreshSecondsRemaining > 0 ? 'Refreshing providers... (' + refreshSecondsRemaining + 's)' : 'Refreshing providers...') : 'Refresh providers' }}</button>
    </div>
    <hr class="bg-green mb-2" style="height: 2px;" />
    <form [formGroup]="cpInfoForm" (ngSubmit)="onSave()">
      <div class="flex flex-col">
        <div class="w-full">
          <mat-form-field class="w-full">
            <mat-label>Select Provider</mat-label>
            <mat-select [formControl]="selectedProviderCtrl" >
              <mat-option>
                <ngx-mat-select-search [formControl]="searchBarFormControl" [noEntriesFoundLabel]="noOptionsText"
                  placeholderLabel="Start typing to find provider"/>
              </mat-option>
              @for (option of filteredProviderList; track option) {
                <mat-option
                  [value]="option.id"
                  class="flex"
                  >
                  {{option.firstName}} {{option.lastName}}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
        <div class="w-full">
          @if (selectedProvider !== null) {
            <div class="flex items-center gap-2 w-full">
              <mat-form-field class="flex-1">
                <mat-label>Select a Provider Group...</mat-label>
                <mat-select [formControl]="groupNameCtrl">
                  @for (group of providerGroups; track group) {
                    <mat-option [value]="group">{{ group }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
              @if (groupNameCtrl.value) {
                <button type="button" class="text-red-600" aria-label="Remove provider from group" (click)="onRemoveProviderFromGroup()">
                  <mat-icon>close</mat-icon>
                </button>
              }
            </div>
          }
        </div>
        <button mat-raised-button color="primary" type="submit" [disabled]="!cpInfoForm.valid">Submit</button>
      </div>
    </form>
  </div>
</app-load-spinner-wrapper>
